module.exports = __webpack_public_path__ + "static/media/miysis_3d_cdcl_dpp_int-cporte-fixe_final.018bd63d.jpg";